import logo from './../../logo.svg';
import './../../static/css/chat.css';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import server from './../../static/json/server.json';
import dictionary from './../../static/json/dictionary.json';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import NewRiddleButton from './NewRiddleButton';
import Shares from './../Shares';
import Comments from './../Comments';
import { Helmet } from 'react-helmet';


import { useParams, useSearchParams } from "react-router-dom";

import 'animate.css';
import './../../static/css/style.css';

import ReactGA from 'react-ga4';
ReactGA.initialize('G-4J51X44PYF');

const SERVER_ADDRESS = server["server"];


const TypingAnimation = ({ text, speed = 100 }) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    setDisplayedText('');
    let index = 0;

    const intervalId = setInterval(() => {
      setDisplayedText((prev) => prev + text.charAt(index));
      index++;
      if (index === text.length) {
        clearInterval(intervalId);
      }
    }, speed);

    return () => clearInterval(intervalId);
  }, [text, speed]);

  return <span>{displayedText}</span>;
};




function botChat(message)  {
  return (
    <div className="chat-container">
      { /* <div className="person-image">
        <img src="/images/robot.png" alt="Person" />
      </div> */ }
      <div className="chat-messages">
        <div className="bubble left">
            <TypingAnimation text={message} speed={30} />
        </div>

      </div>

    </div>
  );
};

function getHintsById(id) {
	const savedHints = localStorage.getItem('guesses-' + id);
	var hintsParsed = savedHints ? JSON.parse(savedHints) : [];
	//console.log(hintsParsed);
	var hintsSorted = hintsParsed.sort((a,b) => a.order - b.order);
	console.log(hintsSorted);
	return hintsSorted;
}

function checkGuess(guess) {
	if(dictionary.includes(guess) ) {
		return false;
	} else {
		return true;
	}
}

function removeBadSigns(text) {
	return text.replace(/[^a-zA-Z]/g, '').toLowerCase();
}

function checkIfFinished(id) {
	var score = localStorage.getItem('riddle-' + id + '-score');
	if (score == undefined) {
		return false;
	} else {
		return true;
	}
}

function checkIfWon(id) {
	var score = localStorage.getItem('riddle-' + id + '-score');
	return (score > 0);
}

function countMessages(id) {
	if(checkIfFinished(id)) {
		if(checkIfWon(id)) {
			return "Congrats! You guessed correctly!";
		} else {
			return "You gave up!";
		}
	} else {
		return "Can you guess what I am?";

	}
}

export default function Guesser({lang}) {

	const { id: urlId } = useParams(); // Get ID from URL like /image/:id
    const [searchParams] = useSearchParams(); // Get ID from query param ?id=ID
    const id = urlId || searchParams.get("id"); // Support both /image/:id and /image?id=ID

	const [newGuess, setNewGuess] = useState("");
	const [error, setError] = useState("");
	const [hint, setHint] = useState("");


	const [message, setMessage] = useState(countMessages(id));

	const [hints, setHints] = useState(getHintsById(id));
	const [lastGuess, setLastGuess] = useState("");

	const [finished, setFinished] = useState(checkIfFinished(id));
	const [needHelp, setNeedHelp] = useState(false);

	const [answer, setAnswer] = useState("");

	function toggleHelp() {
		setNeedHelp(!needHelp);
	}

	useEffect(() => {

    	const fetchUrl = async () => {
        	try {

        		const response = await fetch(SERVER_ADDRESS + "/get-hint", {
        	        method: "POST",
		            headers: { 'Content-Type': 'application/json' },
	                body: JSON.stringify({ "id": id })
        	    });
        	    const shortHint = await response.json();
				if("hint" in shortHint) {
					setHint(shortHint["hint"]);
					localStorage.setItem('riddle-' + id + '-hint', shortHint["hint"]);
					setAnswer(shortHint["answer"]);
				}

        	} catch (error) {

				console.log("error");
				console.log(error);

            }
        }
		fetchUrl();
    }, [id]);


	const handleSubmit = async (event) => {
	    event.preventDefault();

	    if (!newGuess) {
	        setError("No guess");
	        return;
	    }

	    if(checkGuess(newGuess)) {
	        setError("Bad word");
            return;
	    }

	    setError("");
	    setMessage("...");

	    const formData = new FormData();
	    formData.append("guess", newGuess);
	    formData.append("id", id);


	    try {
	      const response = await fetch(SERVER_ADDRESS + "/guess", {
	        method: "POST",
		    headers: {
		        'Content-Type': 'application/json',
		    },
	        body: JSON.stringify({ "guess": newGuess, "id": id })
	      });

	      const data = await response.json();

	      if (response.ok) {
	        const savedHints = localStorage.getItem('guesses-' + id);
	        const hintsParsed = savedHints ? JSON.parse(savedHints) : [];

			console.log(data);

		    const newHint = { "guess": data.guess, "hint": data.funnyHint,  "icon": data.emoji,  "order": data.order };
			var updatedHints = hintsParsed;

			const exists = updatedHints.some(item => item.guess === data.guess);
		    if(!exists) {
		        updatedHints = [...hintsParsed, newHint];
	            localStorage.setItem('guesses-' + id, JSON.stringify(updatedHints));
	            //localStorage.setItem('guesses-' + id + '-time', new Date().now());
	        }

	        setHints(getHintsById(id));
			setLastGuess(data.guess);

			if(data.correct) {
                setMessage("✔ Congrats! I'm " + data.guess);
                setFinished(true);

                localStorage.setItem('riddle-' + id + '-score', updatedHints.length );
                localStorage.setItem('riddle-' + id + '-result', data.guess );
                localStorage.setItem('riddle-' + id + '-icon', data.emoji );

                const finishedRiddles = localStorage.getItem('riddles-finished');
                var updatedFinishedRiddles = finishedRiddles ? parseInt(finishedRiddles) + 1 : 1;
				
                localStorage.setItem('riddles-finished', updatedFinishedRiddles);
                ReactGA.event({
		            category: 'Guesser',
		            action: 'FinishRiddle',
                    value: updatedHints.length
		        });
		        ReactGA.event({
		            category: 'Guesser',
		            action: 'FinishedRiddles',
                    value: updatedFinishedRiddles
		        });

			} else {
                setMessage("❌ " + data.funnyHint);
			}
	      } else {

	      }
	    } catch (error) {

	    } finally {
	        setNewGuess("");
	    }
    };

	async function giveUp() {
		setNeedHelp(false);

		try {
            const response = await fetch(SERVER_ADDRESS + "/guess", {
        	    method: "POST",
        		headers: {
        		    'Content-Type': 'application/json',
        		},
        	    body: JSON.stringify({ "guess": answer, "id": id })
        	});

        	const data = await response.json();
        	console.log(data);

	        const savedHints = localStorage.getItem('guesses-' + id);
	        const hintsParsed = savedHints ? JSON.parse(savedHints) : [];

		    const newHint = { "guess": data.guess, "hint": data.funnyHint,  "icon": data.emoji,  "order": data.order };
			var updatedHints = hintsParsed;

			const exists = updatedHints.some(item => item.guess === data.guess);
		    if(!exists) {
		        updatedHints = [...hintsParsed, newHint];
	            localStorage.setItem('guesses-' + id, JSON.stringify(updatedHints));
	            //localStorage.setItem('guesses-' + id + '-time', new Date().now());
	        }

	        setHints(getHintsById(id));
			setLastGuess(data.guess);


        	setMessage("You gave up! I'm " + data.guess + "!");


            localStorage.setItem('riddle-' + id + '-score', (-1)*(updatedHints.length) );
            localStorage.setItem('riddle-' + id + '-result', data.guess );
            localStorage.setItem('riddle-' + id + '-icon', data.emoji );

            ReactGA.event({
		        category: 'Guesser',
		        action: 'GiveUpRiddle',
                value: hintsParsed.length
		    });


		} catch (error) {

		} finally {
			setNewGuess("");
			setFinished(true);
		}
	}

	const title = "Guessie - Level " + hint;

	var boardCode = (
		<>
			<Helmet>
                    <title>{title}</title>
                    <link rel="canonical" href={"https://www.guessie.com/" + lang + "/guess?id=" + id} />
                    <meta property="og:url" content={"https://www.guessie.com/" + lang + "/guess?id=" + id}  data-react-helmet="true" />
                    <meta property="og:image" content={"https://www.guessie.com/images/games/guesser/default.png"} />
                    <meta property="og:title" content={title}/>
                    <meta property="og:description" content={title}/>


            </Helmet>

			<div className="mainPart">
		        <Container>

		            <Row>


					<div className="person-image">
		                    <img src="/images/robot.png" alt="Person" />
		                  </div>


					<h1> {hint}  </h1>
					{ botChat(message) }


					{
					finished
					? <>
						{
							localStorage.getItem('riddle-' + id + '-score') <= 0
							? <h2> You gave up! The correct word is
							<span className="boldText">  { localStorage.getItem('riddle-' + id + '-result') } </span>! </h2>

							: <h2> You guessed the word <span className="boldText">  { localStorage.getItem('riddle-' + id + '-result') } </span>
							 in {localStorage.getItem('riddle-' + id + '-score')}

							{
								localStorage.getItem('riddle-' + id + '-score') == 1
								? <> try!</>
								: <> tries!</>
							}
							</h2>
						}

						<h2>
						<br/>
						<NewRiddleButton lang={"en"} type={"next"}/> </h2>

						<a href={"/" + lang + "/riddles"}>Show all riddles</a>

						<br/>
						<br/>
						<h2> Share this riddle with friends:</h2>

						<Shares game={"Guessie"} hint={hint} score={localStorage.getItem('riddle-' + id + '-score')} />
						<br/><br/>
						<p><br/><br/> All your guesses: </p>
						</>

					: <>
						<Form onSubmit={handleSubmit}>
							<Form.Control className="form-input guess-input" type="text" placeholder="Type your guess e.g. apple"
				                value={newGuess}  onChange={(e) => { setNewGuess(removeBadSigns(e.target.value)); }}
							 />

							 <span className="error">{ error } </span><br/>


				            <Button className="default-btn important-btn" type="submit">  Guess </Button>

						</Form>

						<div className="helpButton" onClick={() => toggleHelp()}> {
							needHelp
							? <>Close help</>
							: <>Stuck? Tap Here <br/> </>
						}</div>

						{
							needHelp
							? <Row>

								<Col className="optionBox">
									<h4>Option 1. Ask a friend for help </h4>
		                            Send the link to your friend—maybe together you’ll be able to solve the puzzle!
									<Shares game={"Guessie"} hint={hint} score={0} />

								</Col>
								<Col className="optionBox">
									<h4>Option 2. Play different riddle</h4>
									<NewRiddleButton lang={"en"} type={"different"}/><br/>
									Don't worry. You can return to this puzzle at any time through the
									<a href="/en/riddles"> All riddles page</a>.
								</Col>

								<Col className="optionBox">
									<h4>Option 3. Give up</h4>
									<Button className="default-btn" onClick={() => giveUp() }>Give up</Button> <br/>
									If you’re done with this riddle, you can give up anytime.
								</Col>
							</Row>
							: <></>
						}

						</>
					}

					<div className="fakeTable">
					{
						hints.map(hint => (

							<Row className={ hint.guess == lastGuess ? "tableRow lastGuess" : "tableRow" } >
								<div className="guessIcon"> <span> {hint.icon} </span> </div>
								<div className="guessText">
									<span class="bigText">  {hint.guess}</span>  <br/>
								    {hint.hint} </div>
								<div className="bigText hintOrder"> {hint.order} </div>
							</Row>


						))
					}

					</div>

				</Row>

                </Container>


            </div>

            <Comments/>


		</>
	)


    return boardCode;
}

